import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getWhitelistedProviders, updateWhitelist } from '../../api';
import { ADMIN_QUERY_KEYS } from '@/features/admin/api/query-keys';

export const useWhitelistedProviders = () => {
  return useQuery({
    queryKey: ADMIN_QUERY_KEYS.modelProviders.whitelisted,
    queryFn: getWhitelistedProviders,
  });
};

export const useUpdateWhitelist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ providerIds, workspaceId }: { providerIds: string[]; workspaceId?: string }) => {
      return updateWhitelist(providerIds, workspaceId);
    },
    onSuccess: () => {
      void queryClient.refetchQueries({ queryKey: ADMIN_QUERY_KEYS.modelProviders.whitelisted });
    },
  });
};
